import type { ReactNode } from 'react'
import React from 'react'

import * as S from './ConfigurationListItem.styled'

export type ConfigurationListItemProps = {
  title: string
  content?: ReactNode
}

export const ConfigurationListItem = ({ title, content }: ConfigurationListItemProps) => {
  return (
    <S.Container>
      <S.Title>{title}</S.Title>
      {content && <S.Content>{content}</S.Content>}
    </S.Container>
  )
}
